import { mapExtraField } from './ExtraField'
import { TAbstractCatalogConfig } from './AbstractCatalogConfig'

export interface TSingleCatalogConfig extends TAbstractCatalogConfig {
}

export const create = (data?: any): TSingleCatalogConfig => ({
  id: '',
  name: '',
  extraId: '',
  businessIdList: [],
  networkIdList: [],
  acl: [],
  ...data,
  fields: (data.fields || []).map(mapExtraField),
  active: data.active === 'true' || data.active === true,
})
